import { AppSettings } from '@customer-portal/utils';

export const environment: AppSettings = {
  production: true,
  api: {
    baseUrl: 'https://mijn.nieuwestroom.nl/api',
  },
  customerChat: {
    baseUrl: '{CustomerChat.BaseUrl}',
  },
  configcat: {
    sdkKey: 'configcat-proxy/klantportaal-sdk',
    baseUrl: 'https://mijn.nieuwestroom.nl',
  },
  keycloakConfig: {
    url: 'https://auth.nieuwestroom.nl/auth',
    realm: 'klantportaal',
    clientId: 'frontend',
  },
  marketPricesUrl: 'https://prices.nieuwestroom.nl/',
  newsFeedUrl: 'https://stpartnerportalprodweu01.blob.core.windows.net/public-cms/customer-portal/news.json',
  messageFeedUrl: 'https://stpartnerportalprodweu01.blob.core.windows.net/public-cms/customer-portal/messages.json',
};
